(function ($) {
	'use strict';

	/**
	 * Normalize a string by removing accents, special characters, and converting to lowercase.
	 *
	 * @param {string} str - The input string to normalize.
	 * @returns {string} - Normalized string.
	 */
	function emb_normalize_text(str) {
		if (!str) return '';
		return str
			.toString()
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.replace(/[^a-zA-Z0-9\s]/g, '')
			.toLowerCase()
			.trim();
	}

	/**
	 * Fetch roaming data via AJAX based on selected country.
	 *
	 * @param {string} country  - Selected country name.
	 * @param {string} flag_src - URL of the country flag image.
	 */
	function emb_fetch_roaming_data(country, flag_src) {
		if (!country || typeof _emb_coverage_suite_roaming === 'undefined') return;

		$.ajax({
			type: 'POST',
			url: _emb_coverage_suite_roaming.ajax_url,
			dataType: 'json',
			data: {
				action: 'emb_roaming',
				data: {
					nonce: _emb_coverage_suite_roaming.nonce,
					country: country
				}
			},
			beforeSend: function () {
				$('.js-roaming-result').addClass('js-roaming-result-hidden');
			},
			success: function (res) {
				if (!res || res.status !== 'OK' || !res.response) return;

				const data = res.response;

				let call_zone = '-';
				let sms = '-';
				let internet = '-';

				if (data.rates && data.rates.calls && typeof data.rates.calls.call_zone_1 !== 'undefined') {
					call_zone = data.rates.calls.call_zone_1;
				}

				if (data.rates && typeof data.rates.sms !== 'undefined') {
					sms = data.rates.sms;
				}

				if (data.rates && typeof data.rates.data !== 'undefined') {
					internet = data.rates.data;
				}

				const result = $('.js-roaming-result');

				// Country name and flag
				result.find('.js-roaming-country').text(country);
				const flag = result.find('.js-roaming-flag');
				if (flag_src) {
					flag.attr('src', flag_src).attr('alt', country).show();
				} else {
					flag.hide();
				}

				// Rates
				result.find('.js-roaming-call').text(call_zone);
				result.find('.js-roaming-sms').text(isNaN(parseFloat(sms)) ? sms : sms + ' €');
				result.find('.js-roaming-data').text(internet);

				// Infobox: zone and description
				const infobox = result.find('.js-roaming-infobox');
				const zone = data.zone ? 'Zona ' + data.zone : (data.zone_name || null);

				let info = null;
				if (data.zone) {
					const zone_el = result.find('.js-roaming-zone-content[data-zone="' + data.zone + '"]');
					info = zone_el.length ? zone_el.html() : (data.info || data.description || null);
				} else {
					info = data.info || data.description || null;
				}

				if (zone || info) {
					result.find('.js-roaming-zone').text(zone || '');
					result.find('.js-roaming-infobox-content').html(info || '');
					infobox.show();
				} else {
					infobox.hide();
				}

				result.removeClass('js-roaming-result-hidden');
			},
			error: function (xhr) {
				console.error('Roaming AJAX error', xhr);
			}
		});
	}

	/**
	 * Hide the list of countries.
	 *
	 * @param {jQuery} input - The input element.
	 * @param {jQuery} list - The list element.
	 */
	function emb_close_country_list(input, list) {
		list.hide();
		input.attr('aria-expanded', 'false');
	}

	/**
	 * Filter country list based on user input.
	 *
	 * @param {string} value - The input value to search for.
	 * @param {jQuery} items - List of all country elements.
	 * @param {jQuery} list - The list container to show/hide.
	 */
	function emb_filter_country_list(value, items, list) {
		const normalized_value = emb_normalize_text(value);
		let visible_count = 0;

		items.each(function () {
			const item = $(this);
			const country = item.data('country');

			if (!country) {
				item.addClass('js-roaming-result-hidden');
				return;
			}

			const normalized_country = emb_normalize_text(country);
			const match = normalized_country.indexOf(normalized_value) !== -1;

			if (match) {
				item.removeClass('js-roaming-result-hidden');
				visible_count++;
			} else {
				item.addClass('js-roaming-result-hidden');
			}
		});

		if (visible_count === 0) {
			list.hide();
		} else {
			list.show();
		}
	}

	/**
	 * Bind click event to country selection items.
	 *
	 * @param {jQuery} list - The list element containing country buttons.
	 * @param {jQuery} input - The search input element.
	 * @param {jQuery} hidden_input - The hidden input to store selected country.
	 */
	function emb_handle_country_selection(list, input, hidden_input) {
		list.on('click', '.roaming-list__button', function () {
			const country = $(this).data('country');
			const flag_src = $(this).find('.roaming-list__flag').attr('src') || null;
			input.val(country);
			hidden_input.val(country);
			list.hide();
			input.attr('aria-expanded', 'false');
			emb_fetch_roaming_data(country, flag_src);
		});
	}

	/**
	 * Close the country list when clicking outside the form.
	 *
	 * @param {jQuery} form - The form container element.
	 * @param {jQuery} list - The list element to close.
	 * @param {jQuery} input - The input element to update accessibility state.
	 */
	function emb_close_on_outside_click(form, list, input) {
		$(document).on('click', function (e) {
			if (!form.is(e.target) && form.has(e.target).length === 0) {
				emb_close_country_list(input, list);
			}
		});
	}

	/**
	 * Initialize the roaming search functionality.
	 */
	function emb_init_roaming_search() {
		const form = $('.js-roaming-form');
		if (!form.length) return;

		const input = form.find('.js-roaming-search');
		const list = form.find('.js-roaming-list');
		const hidden_input = form.find('.js-roaming-input');
		const items = form.find('.roaming-list__item');

		input.on('click', function () {
			const value = $(this).val().trim();
			emb_filter_country_list(value, items, list);
			input.attr('aria-expanded', 'true');
		});

		input.on('input', function () {
			const value = $(this).val().trim();
			emb_filter_country_list(value, items, list);
		});

		emb_handle_country_selection(list, input, hidden_input);
		emb_close_on_outside_click(form, list, input);
	}

	/**
	 * Initialize the roaming module when document is ready.
	 */
	function emb_init_roaming_module() {
		emb_init_roaming_search();
	}

	// Initialize when DOM is ready
	$(function () {
		emb_init_roaming_module();
	});

})(jQuery);
